import React, { Component } from "react";
import withGlobalData from "../../../common/withGlobalData";
import { getCostComponents } from "../../../../../services/setup/sales/salesSetupService";
import CustomDataTableSearch from "../../../../../partials/content/CustomDataTableSearch";

class SearchCostComponent extends Component {
  state = { reload: this.props.globalData.reload, costComponents: [] };

  componentDidMount() {
    this.getCostComponents();
  }

  componentDidUpdate() {
    const { globalData } = this.props;
    const { reload } = this.state;
    if (globalData.reload !== reload) {
      this.getCostComponents();
      this.setState({ reload: globalData.reload });
    }
  }

  async getCostComponents() {
    const response = await getCostComponents();
    const { data } = response.data;
    this.setState({ open: false, costComponents: data.costComponents });
  }

  render() {
    const { costComponents } = this.state;
    const { onSelectCostComponent } = this.props;
    return (
      <CustomDataTableSearch
        data={costComponents}
        onRefreshData={() => {
          this.getCostComponents();
        }}
        onSelectedData={(rowData, originalEvent) => {
          onSelectCostComponent(rowData);
        }}
        columns={[
          {
            field: "select",
            body: (rowData) => (
              <React.Fragment>
                <button
                  type="button"
                  className="btn btn-label-success btn-sm btn-pill btn-bold"
                  onClick={() => onSelectCostComponent(rowData)}
                >
                  Select <i className="fas fa-angle-double-right"></i>
                </button>
              </React.Fragment>
            ),
          },
          {
            header: "Cost Component Name",
            field: "costComponentName",
            body: null,
            sortable: true,
          },
        ]}
      />
    );
  }
}

export default withGlobalData(SearchCostComponent);
